import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useAuth } from '../../context/AuthContext';
import { useChatWhatsApp } from '../../context/ChatWhatsAppContext';
import { useOperador } from '../../context/OperadorContext';
import { formatCPFCNPJ } from '../../utils/formatCPFCNPJ';


export function Home() {
  const { decodedToken, cookies, validToken } = useAuth()
  const [, setCookies] = useCookies(['token', 'user', 'whatsapp'])
  const { loginChat } = useChatWhatsApp()
  const { clearData } = useOperador()

  useEffect(() => {
    validToken(cookies?.token)
    if (!cookies?.user) {
      const decoded = decodedToken()
      setCookies('user', {
        id_operador: decoded.id_usuario,
        nome: decoded.nome,
        id_perfil: decoded.id_perfil,
        id_usuario_gestor: decoded.id_usuario_gestor,
        usuarioTransbordo: decoded.usuarioTransbordo,
        senhaTransbordo: decoded.senhaTransbordo
      })
    }
    clearData()
  }, [])

  // useEffect(() => {
  //   if (!cookies?.whatsapp) {
  //     loginChat({ login: '965.773.472-04', password: '123456789' }).then((res) => {
  //       setCookies('whatsapp', {
  //         token: res.token, queueId: res.queueId
  //       })
  //     })
  //   }
  // }, [])


  useEffect(() => {
    if (!cookies?.whatsapp && cookies?.user) {
      // loginChat({ login: '092.314.671-74', password: '123456789' })

      loginChat({ login: cookies?.user.usuarioTransbordo ? formatCPFCNPJ(cookies?.user.usuarioTransbordo) : '', password: cookies?.user.senhaTransbordo }).then((res) => {
        setCookies('whatsapp', {
          token: res.token, queueId: res.queueId
        })
      })
    }
  }, [cookies?.user])


  return (
    <>
      <section>
        <div className="flex h-sideBar w-full mt-4 p-6 flex-col bg-[#f1f5f9]">
          <h2 className='text-2xl text-primary my-4 font-bold'>Olá, seja bem-vindo ao Aciona One!</h2>
        </div>
      </section>
    </>
  );
}
